import { createContext, useContext } from "react";
import { Ruleset } from "../../domain/ruleset";

export const RulesetContext = createContext<Ruleset | null>(null);

export function useRuleset() {
  const ruleset = useContext(RulesetContext);
  if (!ruleset) {
    throw new Error("Missing ruleset in React context.");
  }
  return ruleset;
}
